import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../context/LangContext";

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t.manifesto.chapters;
  return (
    <section className="relative bg-brand-navy py-8 border-y border-white/10 overflow-hidden" data-testid="manifesto-marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {chapters.map((c, i) => (
          <div key={i} className="flex items-center gap-6 mx-8">
            <span className="font-condensed text-xs text-brand-azure font-semibold">0{i + 1}</span>
            <span className="font-display text-2xl sm:text-3xl font-medium text-white/90 uppercase tracking-wide">{c}</span>
            <span className="text-brand-azure/40 text-2xl">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
